import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PurchaseRepository, StripeTransaction } from "../purchase/purchase-repository";
import dayjs from "dayjs";
import { DecimalPipe } from "@angular/common";
import { CentsToDollarsPipe } from "@shared/src/public-api";

@Component({
	selector: "jhm-transaction-complete",
	templateUrl: "./transaction-complete.html",
	styleUrls: ["./transaction-complete.scss"],
	imports: [DecimalPipe, CentsToDollarsPipe]
})
export class TransactionCompleteComponent implements OnInit
{
	@Input()
	public transactionId: string;
	@Input()
	public status: string;
	public transaction: StripeTransaction;
	public loading: boolean = true;
	@Output()
	public closeModal: EventEmitter<void> = new EventEmitter();

	private stripeRepository: PurchaseRepository;

	public constructor(stripeRepository: PurchaseRepository)
	{
		this.stripeRepository = stripeRepository;
	}

	public ngOnInit(): void
	{
		if (this.transactionId)
		{
			this.stripeRepository.getTransaction(this.transactionId).subscribe((transaction: StripeTransaction) =>
			{
				this.transaction = transaction;
				this.loading = false;
			});
		}
		else
		{
			this.loading = false;
		}
	}

	public closeModalClicked(): void
	{
		this.closeModal.emit();
	}

	public getDateSecondsSinceEpoch(milliseconds: number): string
	{
		return dayjs.unix(milliseconds / 1000).format("MMMM D, YYYY");
	}
}
